import api from './api';

export const getClients = (params) =>
  api.get('/api/v1/clients', { params }).then((r) => r.data.data);

export const getClient = (id) =>
  api.get(`/api/v1/clients/${id}`).then((r) => r.data.data);

export const createClient = (data) =>
  api.post('/api/v1/clients', data).then((r) => r.data.data);

export const updateClient = (id, data) =>
  api.put(`/api/v1/clients/${id}`, data).then((r) => r.data.data);

export const deleteClient = (id) =>
  api.delete(`/api/v1/clients/${id}`).then((r) => r.data);

export const inviteClient = (id) =>
  api.post(`/api/v1/clients/${id}/invite`).then((r) => r.data);

export const exportFhir = (id) =>
  api.get(`/api/v1/clients/${id}/fhir`).then((r) => r.data);

export const previewClientImport = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/api/v1/clients/import/preview', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data.data);
};

export const confirmClientImport = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/api/v1/clients/import/confirm', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};
